import React from "react";
import { Button, Card, Chip, CardActionArea, CardActions, CardContent, Stack, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { setSelectedProject } from "../../api/services/projects/projectsSlice";
import { useDispatch } from "react-redux";

export const projectStatusColor = (status) => {
  if (status === 'Active') return 'text.secondary';
  if (status === 'Inactive') return 'text.warning';
  if (status === 'Complete') return 'text.success';
  if (status === 'Stopped') return 'text.error';
  return 'text.secondary';
}

export default function ProjectCard({ projectData }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigateToProjectPage = () => {
    // Before navigating, set the selected project to null, so that if a project was previously selected it isn't shown until the newly selected project data loads
    dispatch(setSelectedProject(null));
    // Project data is re-fetched when going to the specific project's page, GET request done on initial load there instead. Just pass the project UUID and slug and use that to query
    navigate(`/projects/${projectData.slug}-${projectData.id}`, { state: { initialProjectData: projectData } });
  };

  return (
    <Card elevation={4} sx={{ minWidth: 275 }}>
        <CardContent>
        <Typography variant="h5" component="div">
          {projectData.name}
        </Typography>
        <Typography sx={{ fontSize: 14 }} color="text.secondary">
          {projectData.project_number ? projectData.project_number : 'No project number'}
        </Typography>
        <Typography sx={{ fontSize: 14 }} color={projectStatusColor(projectData.status)}>
          {projectData.status} {projectData.completion_date && `(${projectData.completion_date})`}
        </Typography>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Created by: {projectData.created_by.full_name}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ marginBottom: 1 }}>
          <Typography variant="body2">{`Assigned User(s): `}</Typography>
          {projectData.assignment_projects.length === 0 && <Chip
              label="None"
              title="No surveyors"
              size="small"
              variant="outlined"
              style={{ color: "#9E9790" }}
            />}
          {projectData.assignment_projects
            .filter((projectAssignment) => projectAssignment.permission_level === 'ProjectEditor')
            .map((projectAssignment, index) => (
              <Chip
                key={`project-leads-${index}`}
                label={projectAssignment.user.full_name}
                title="Assigned to project as a Project Editor"
                size="small"
                color="secondary"
              />
            ))}
          {projectData.assignment_projects
            .filter((projectAssignment) => projectAssignment.permission_level !== 'ProjectEditor')
            .map((projectAssignment, index) => (
              <Chip
                key={`project-standard-users-${index}`}
                label={projectAssignment.user.full_name}
                title="Assigned to project as a Standard User"
                size="small"
              />
            ))}
        </Stack>
      </CardContent>
      
      <CardActions>
        <Button size="small" color="secondary" onClick={() => handleNavigateToProjectPage()} aria-label="Navigate to project page and data forms">View Project</Button>
      </CardActions>
    </Card>
  );
}
